<template>
  <v-container style="max-width: 1800px">
    <v-card class="ma-4">
      <v-toolbar color="primary" dark>
        Local da instalação 
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-container class="ma-4">
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="site.cityName"
                :loading="loading"
                :items="items"
                :search-input.sync="search"
                cache-items
                flat
                hide-no-data
                hide-details
                label="Cidade"
                @blur="changed"
                :disabled="disabled"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                label="CEP"
                hide-details="auto"
                v-model="site.zipCode"
                @blur="updatedZipCode"
                v-mask="'##.###-###'"
                :disabled="disabled"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                label="Rua"
                hide-details="auto"
                v-model="site.streetAddress"
                :disabled="disabled"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                label="Número"
                hide-details="auto"
                v-model="site.streetAddressNumber"
                     :disabled="disabled"
           
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                label="Complemento"
                hide-details="auto"
                v-model="site.streetAddressLine2"
                     :disabled="disabled"
           
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                label="Bairro"
                hide-details="auto"
                v-model="site.neighborhood"
                     :disabled="disabled"
           
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card class="mx-4">
      <v-toolbar color="primary" dark>
        Dados do orçamento
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-container class="ma-4">
          <v-row>
            <b class="mx-4">Dados de consumo</b>
          </v-row>
          <v-row v-if="site.electricalProps">
            <v-col cols="12" md="1">
              <v-select
                class="my-5"
                v-model="site.electricalProps.voltage"
                :items="voltageOptions"
                label="Tensão"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>
                     <v-col cols="12" md="1">
              <v-select
                class="my-5"
                v-model="site.electricalProps.averageBilling.type"
                :items="typeOptions"
                label="Tipo"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                class="my-5"
                v-model="site.electricalProps.phases"
                :items="phasesOptions"
                label="Fases"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="2"> 
              <v-select
                v-model="inputConsumption"
                :items= "inputConsumptionOptions"
                item-text="text"
                item-value="value"
                label= "Tipo de cálculo"
     :disabled="disabled"
           
                >
              </v-select>
            </v-col>
            <!-- inputConsumption - false = consumo -->
            <v-col cols="12" md="2" v-if= "inputConsumption">
              <vuetify-money
                @change.native="updateConsumption"
                v-model.number="site.electricalProps.averageBilling.quantity"
                label="Consumo (kWh)"
                v-bind:options="$globalFunctions.optionsDecimal"
                     :disabled="disabled"
           
              />
            </v-col>
            <v-col cols="12" md="2" v-if= "!inputConsumption">
              <vuetify-money
                @change.native="updateConsumption"
                v-model.number="site.electricalProps.averageBilling.total"
                label="Conta(R$)"
                v-bind:options="$globalFunctions.optionsMoneyBr"
                     :disabled="disabled"
           
              />
            </v-col>

            <v-col cols="12" md="2">
              <vuetify-money
                @change.native="updateConsumption"
                v-model.number="site.electricalProps.averageBilling.price"
                label="Tarifa (R$)"
                v-bind:options="$globalFunctions.optionsMoneyBr"
                     :disabled="disabled"
           
              />
            </v-col>

            <v-col cols="12" md="2" v-if= "inputConsumption">
              <vuetify-money
                disabled
                v-model.number="site.electricalProps.averageBilling.total"
                label="Conta média (R$)"
                v-bind:options="$globalFunctions.optionsMoneyBr"
                
              />
            </v-col>
               <v-col cols="12" md="2" v-if= "!inputConsumption">
              <vuetify-money
                disabled
                v-model.number="site.electricalProps.averageBilling.quantity"
                label="Consumo (kWh)"
                v-bind:options="$globalFunctions.optionsDecimal"
              />
            </v-col>

            
          </v-row>

          <v-row>
            <b class="mx-4">Dados do gerador fotovoltaico</b>
          </v-row>
          <v-row>
            <v-col cols="12" md="2"  v-show= "(user.enterpriseId !== 'njqG1gP7ANMQIM5ZKcyW')"  >
              <v-select
                class="my-5"
                v-model="site.solarRequest.customKit"
                :items="customKitOptions"
                label="Tipo"
                item-text="text"
                item-value="value"
                @change="changeCustomKit"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="2" v-if="!site.solarRequest.customKit">
              <v-switch
                v-model="site.solarRequest.estimated"
                label="Cálculo estimado"
                     :disabled="disabled"
           
              ></v-switch>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                class="my-5"
                v-model="site.solarRequest.manufacturer"
                :items="manufacturerOptions"
                label="Fabricante"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="5">
              <v-select
                class="my-5"
                @change="moduleChanged"
                v-model="site.solarRequest.moduleId"
                :items="moduleOptions"
                label="Módulo"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                class="my-5"
                @change="structureChanged"
                v-model="site.solarRequest.structureId"
                :items="structureOptions"
                label="Estrutura"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="2">
              <v-select
                class="my-5"
                v-model="site.solarRequest.quoteProfileId"
                :items="quoteProfilesOptions"
                label="Tipo de orçamento"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="2" v-if="site.solarRequest.customKit">
              <v-select
                class="my-5"
                v-model="site.solarRequest.components.stringbox"
                :items="yesNoOptions"
                label="Incluir stringbox"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="2"  v-if="site.solarRequest.customKit">
              <v-select
                class="my-5"
                v-model="site.solarRequest.components.transformer"
                :items="yesNoOptions"
                label="Incluir transformador"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>
          </v-row>

          <v-row>
            <b class="mx-4">Dados de cálculo</b>
          </v-row>

          <v-row>
            <v-col cols="12" md="2">
              <v-switch v-model="maxSavings" label="Máxima economia" @change="updateConsumption"      :disabled="disabled"
           ></v-switch>
            </v-col>

            <v-col cols="12" md="3">
              <v-select
                class="my-5"
                v-model="site.solarRequest.calcType"
                :items="calcTypeOptions"
                @change="calc"
                label="Tipo de cálculo"
                item-text="text"
                item-value="value"
                dense
                     :disabled="disabled"
           
              >
              </v-select>
            </v-col>

            <v-col
              cols="12"
              md="3"
              v-show="site.solarRequest.calcType == 'kWh'"
            >
              <vuetify-money
                :disabled="maxSavings ||disabled"
                @change.native="calc"
                v-model.number="site.solarRequest.production"
                label="Produção desejada (kWh)"
                v-bind:options="$globalFunctions.optionsDecimal"
                
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-show="site.solarRequest.calcType == 'kWh'"
            >
              <vuetify-money
                disabled
                v-model.number="site.solarRequest.dcPower"
                label="Potência (kWp)"
                v-bind:options="$globalFunctions.optionsDecimal"
              />
            </v-col>

            <v-col
              cols="12"
              md="3"
              v-show="site.solarRequest.calcType == 'kWp'"
            >
              <vuetify-money
                :disabled="maxSavings||disabled"
                @change.native="calc"
                v-model.number="site.solarRequest.dcPower"
                label="Potência (kWp)"
                v-bind:options="$globalFunctions.optionsDecimal"
              />
            </v-col>

            <v-col
              cols="12"
              md="3"
              v-show="site.solarRequest.calcType == 'kWp'"
            >
              <vuetify-money
                disabled
                v-model.number="site.solarRequest.production"
                label="Produção desejada (kWh)"
                v-bind:options="$globalFunctions.optionsDecimal"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="newAverageBilling.savingsPercentage"
                label="Economia (%)"
                @blur="savingsUpdate"
              :disabled="maxSavings||disabled"
              >
                <template
                  v-slot:append
                  v-if="
                    (newAverageBilling.quantity - 
                    this.site.electricalProps.averageBilling.minAmount )<1
                  "
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="green"> mdi-check </v-icon>
                    </template>
                    Máxima economia
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn class="ma-4 secondary" @click="calcQuote">
              <span v-show="!calculating"
                ><v-icon>mdi-save</v-icon> Cálculo</span
              >
              <v-progress-circular
                v-show="calculating"
                indeterminate
                color="white"
              ></v-progress-circular>
            </v-btn>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import cityNames from "@/libraries/data/cityNames.js";
import Module from "@/libraries/classes/devices/Module.js";
import hebelApi from '../../../../libraries/hebel/hebelApi';

export default {
  name: "site-card",
  props: [
    "site",
    "disabled",
    "structureOptions",
    "structures",
    "modules",
    "generators",
    "loadedCity",
    "calculating",
    "quoteProfilesOptions",
    "inverterManufacturers",
    "generatorManufacturers",
  ],

  components: {},

  data() {
    return {
      user:{},
      inputConsumption:false,
      maxSavings: true,
      inputConsumptionOptions:[
        {value:false, text:"Conta" },
        {value:true, text:"Consumo" },
      ],
    typeOptions: [
        { value: "B1", text: "B1" },
        { value: "B2", text: "B2" },
        { value: "B3", text: "B3" },
        
      ],
      calcTypeOptions: [
        { value: "kWp", text: "Potência(kWp)" },
        { value: "kWh", text: "Produção (kWh)" },
      ],
      voltageOptions: [
         {value:127, text:"127V"},
        { value: 220, text: "220V" },
        { value: 380, text: "380V" },
        { value: 440, text: "440V" },
      ],
      yesNoOptions: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      completeOptions: [
        { value: false, text: "Somente kit" },
        { value: true, text: "Completo" },
      ],
      customKitOptions: [
        { value: true, text: "Kit aberto" },
        { value: false, text: "Kit fechado" },
      ],
      phasesOptions: [
        { value: 1, text: "Monofásico" },
        { value: 2, text: "Bifásico" },
        { value: 3, text: "Trifásico" },
      ],
      loading: false,
      items: [],
      search: null,
      select: null,
      filt: [],
      newAverageBilling:{
           description: "Energia ativa",
            factor: 1,
            minAmount: 100,
            price: 0,
            quantity: 0,
            total: 0,
            type: "B2",
            unit: "kWh",
      }
    }
  },

  computed: {
    manufacturerOptions: function () {
      var options = [];
      var a = 0;
      if (this.site.solarRequest.customKit) {
        for (a = 0; a < this.inverterManufacturers.length; a++)
          options.push({
            value: this.inverterManufacturers[a],
            text: this.inverterManufacturers[a],
          });
      } else {
        for (a = 0; a < this.generatorManufacturers.length; a++)
          options.push({
            value: this.generatorManufacturers[a],
            text: this.generatorManufacturers[a],
          });
      }
      return options;
    },

    moduleOptions: function () {
      var options = [];
      var a = 0;
      var modules;
        for (a = 0; a < this.modules.length; a++)
          options.push({
            value: this.modules[a].id,
            text: `(${this.modules[a].manufacturer}) ${this.modules[a].code} `,
          });
      return options;
    },
    
  },
  async mounted() {
    this.updateConsumption();
    this.calc();
  },
  created(){
    this.user = this.$session.get("user");
  },
  //loadedCity
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
    loadedCity: function (newLoad, oldLoad) {
      this.search = this.site.cityName;
    },
  },
  methods: {
      updateNewAverageBilling () {
      var billing = {
        description: "Energia ativa",
        factor: 1,
        minAmount: 100,
        price: 0,
        quantity: 0,
        total: 0,
        type: "B2",
        unit: "kWh",
      };

      if (!this.site.solarRequest.production) {
        return billing;
      }
      billing = Object.assign({}, this.site.electricalProps.averageBilling);
      var consumption = this.site.electricalProps.averageBilling.quantity;
      var minAmount = this.site.electricalProps.averageBilling.minAmount;
      var production = this.site.solarRequest.production;
      var newConsumption = 0;
      var credits = 0;

      if (consumption - production <= minAmount) {
        newConsumption = minAmount;
        credits = production - (consumption - minAmount);
      }

      if (consumption - production > minAmount) {
        newConsumption = consumption - production;
        credits = 0;
      }

      billing.quantity = newConsumption;
      billing.total = billing.quantity * billing.price;
      billing.credits = credits;
      billing.savings =    this.site.electricalProps.averageBilling.total - billing.total;
      
      billing.savingsPercentage =Math.round(  (100 * billing.savings) /
        this.site.electricalProps.averageBilling.total);

      this.newAverageBilling = billing;
    },
    savingsUpdate(){
      if (!this.site.solarRequest.module) {
        console.log("no module");
        return;
      }

      if (!this.site.electricalProps) {
        console.log("no electrical props");
        return;
      }

      if (this.site.electricalProps.phases == 1)
        this.site.electricalProps.averageBilling.minAmount = 30;
      if (this.site.electricalProps.phases == 2)
        this.site.electricalProps.averageBilling.minAmount = 50;
      if (this.site.electricalProps.phases == 3)
        this.site.electricalProps.averageBilling.minAmount = 100;


      this.newAverageBilling.quantity = this.site.electricalProps.averageBilling.quantity* ((100- this.newAverageBilling.savingsPercentage)/100);
        if(this.newAverageBilling.quantity <this.site.electricalProps.averageBilling.minAmount)
        this.newAverageBilling.quantity = this.site.electricalProps.averageBilling.minAmount;

      this.site.solarRequest.production = this.round( this.site.electricalProps.averageBilling.quantity -  this.newAverageBilling.quantity )
     //savingsPercentage

      this.newAverageBilling.total = this.newAverageBilling.quantity * this.newAverageBilling.price;
      //billing.credits = credits;

       this.newAverageBilling.savings =    this.site.electricalProps.averageBilling.total -  this.newAverageBilling.total;
      
      this.newAverageBilling.savingsPercentage =Math.round(  (100 * this.newAverageBilling.savings) /
        this.site.electricalProps.averageBilling.total);
         
      if (this.site.city && this.site.city.yield) {
          this.site.solarRequest.dcPower = this.round(
            this.site.solarRequest.production /
              (this.site.city.yield.average *
                (this.site.solarRequest.efficiency / 100) *
                (this.site.solarRequest.module.performanceOverYears[0] / 100))
          );
 
      }
    },
    async updatedZipCode() {
      var info = await this.$globalFunctions.searchZipCode(this.site.zipCode);
      this.search = info.cityName;
      this.site.cityName = info.cityName; 
      this.site.streetAddress = info.streetAddress;
      this.site.neighborhood = info.neighborhood;
    },

    changeCustomKit() {
      if( this.manufacturerOptions.length>0)
        this.site.solarRequest.manufacturer = this.manufacturerOptions[0].value;
    },
    calcQuote() {
      this.calc();
      this.$emit("calcQuote");
    },

    querySelections(v) {
      this.loading = true;
      setTimeout(() => {
        this.items = cityNames.filter((e) => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },

    structureChanged() {
      var x = this.structures.find(
        (element) => element.id == this.site.solarRequest.structureId
      );
      var s = Object.assign({}, x);
      this.site.solarRequest.structure = s;
    },
    moduleChanged() {
      console.log("moduleChagend");
      var x = this.modules.find(
        (element) => element.id == this.site.solarRequest.moduleId
      );
      var m = new Module();
      m = Object.assign(m, x);
      this.site.solarRequest.module = m;
      this.calc();
    },
    async changed() {
      console.log("blur" + this.site.cityName);
      this.site.city = await hebelApi.cities.get(this.site.cityName);
      //this.site.stateName = this.site.cityName;
      //this.site.stateName = this.site.cityName.substring(this.site.cityName.length-2, this.site.cityName.length);
      //alert( this.site.stateName)
      
      //console.log(str.substring(str.length-2, str.length));
    },
    simpleSuggestionList() {
      return cityNames;
    },
    calc() {
      console.log("calc");
      if (!this.site.solarRequest.module) {
        console.log("no module");
        return;
      }

      if (!this.site.electricalProps) {
        console.log("no electrical props");
        return;
      }

      if (this.site.electricalProps.phases == 1)
        this.site.electricalProps.averageBilling.minAmount = 30;
      if (this.site.electricalProps.phases == 2)
        this.site.electricalProps.averageBilling.minAmount = 50;
      if (this.site.electricalProps.phases == 3)
        this.site.electricalProps.averageBilling.minAmount = 100;

      console.log("calc");

      if (this.site.city && this.site.city.yield) {
        if (this.site.solarRequest.calcType == "kWp") {
          this.site.solarRequest.production = this.round( this.site.solarRequest.dcPower* this.site.city.yield.average * (this.site.solarRequest.efficiency / 100) *
              (this.site.solarRequest.module.performanceOverYears[0] / 100)
          );
        }
        if (this.site.solarRequest.calcType == "kWh") {
          this.site.solarRequest.dcPower = this.round( this.site.solarRequest.production / (this.site.city.yield.average *
                (this.site.solarRequest.efficiency / 100) *    (this.site.solarRequest.module.performanceOverYears[0] / 100))
          );
        }
        this.site.electricalProps.averageBilling.total = this.round(
          this.site.electricalProps.averageBilling.quantity *
            this.site.electricalProps.averageBilling.price
        );
      }
    },

    updateConsumption() {
      if (!this.site.solarRequest.module) {
        console.log("no module");
        return;
      }

      if (!this.site.electricalProps) {
        console.log("no electrical props");
        return;
      }

      if (this.site.electricalProps.phases == 1)
        this.site.electricalProps.averageBilling.minAmount = 30;
      if (this.site.electricalProps.phases == 2)
        this.site.electricalProps.averageBilling.minAmount = 50;
      if (this.site.electricalProps.phases == 3)
        this.site.electricalProps.averageBilling.minAmount = 100;

      if(this.inputConsumption){ //input quantity
              this.site.electricalProps.averageBilling.total = this.round(
        this.site.electricalProps.averageBilling.quantity *
          this.site.electricalProps.averageBilling.price
          );
      }else{//Input total 
              this.site.electricalProps.averageBilling.quantity = this.round(
        this.site.electricalProps.averageBilling.total /
          this.site.electricalProps.averageBilling.price
          );
        
      }
      
      this.site.solarRequest.production = this.round( this.site.electricalProps.averageBilling.quantity -this.site.electricalProps.averageBilling.minAmount  )
      if(this.site.solarRequest.production <0)
        this.site.solarRequest.production  =0;
      
      if (this.site.city && this.site.city.yield) {
          this.site.solarRequest.dcPower = this.round(
            this.site.solarRequest.production /
              (this.site.city.yield.average *
                (this.site.solarRequest.efficiency / 100) *
                (this.site.solarRequest.module.performanceOverYears[0] / 100))
          );
 
      }

      this.updateNewAverageBilling();
    },

    
    round(value) {
      return Math.round(value * 100) / 100;
    },
    updateDcPower() {
      //      this.site.solarRequest.
      // }
    },
  },
};
</script>

<style scoped>
vue-simple-suggest {
  border-style: solid;
  border-color: lightgray;
  color: gray;

  border-radius: 40px;
  height: 50px;
  width: 90%;
  background-color: transparent;

  padding-left: 15px;
  padding-top: 12.5px;
  padding-bottom: 12.5px;
  margin: 2%;
  margin-left: 20px;

  text-indent: 7.5%; /* "Alinhar" o texto do select*/
}
</style>